import {useRouter} from 'next/router'
import {useCallback} from 'react'

import {QRType} from '$constants/insurance/qrBridgeTitle'
import {INTERNAL_ROUTES} from '$constants/internal-routes'
import {useValidApp} from '$hooks/useValidApp'
import {BASE_PATH, URL} from '$share/config'

import type {MouseEvent, FC} from 'react'

interface BannerProps {
    onButtonClick?: (e: MouseEvent<HTMLButtonElement>) => void
}

export function useInsuranceBannerHooks({hasValidInsurances}: {hasValidInsurances: boolean}) {
    const {isValidApp} = useValidApp()
    const router = useRouter()

    const handleButtonClick = useCallback(
        (_: MouseEvent<HTMLButtonElement>) => {
            router.replace(
                {
                    pathname: router.pathname,
                    query: {
                        ...router.query,
                        showAppDownloadQR: true,
                        appBridgeUrl: `${URL.NEW_PAY}${BASE_PATH}${INTERNAL_ROUTES.INSURANCE_MY_HOME}`,
                        qrType: QRType.INSU,
                    },
                },
                undefined,
                {shallow: true},
            )
        },
        [router],
    )

    const getBanner = useCallback(
        <Props extends BannerProps>(Component: FC<Props>) =>
            (props: Props) => {
                if (!hasValidInsurances) {
                    if (!isValidApp) {
                        return <Component {...props} onButtonClick={handleButtonClick} />
                    }
                    return <Component {...props} />
                }

                return null
            },
        [handleButtonClick, hasValidInsurances, isValidApp],
    )

    return {getBanner}
}
